<div class="payment-result__state payment-result__state--duplicated">
  <p>
    ⚠️ Tu pago con número de operación
    <strong>{{ message().operationNumber || '—' }}</strong>
    ya ha sido validado anteriormente.
  </p>
</div>
